import { Injectable } from '@angular/core';
import { Random, SearchResult } from 'src/app/shared';
import { Http } from 'src/app/shared/services/http.service';

import {
  SaveMessageActionRequest,
  SaveMessageResponse,
  SendMessage,
} from '../models/Communications';
import { MileageDetail } from '../models/Mileages';
import {
  SubmitMileageRequest,
  SubmitMileageResponse,
} from '../models/mileage-request';

@Injectable({
  providedIn: 'root',
})
export class MileageService {
  constructor(private http: Http, public random: Random) {}

  async getMileageData(
    source: string,
    claimId: string,
    lob: string
  ): Promise<MileageDetail> {
    const rnd = this.random.getNumber(1000);

    let path = '/api/claim/mileages';

    if (claimId != null) {
      path = `/api/claim/mileages/${source}/${claimId}/${lob}`;
    }

    return await this.http.get<MileageDetail>(path + '?' + rnd, {
      cache: false,
      timeout: 0,
    });
  }

  async verifyCityStateZip(input: any) {
    /*
    {
      City: input.City,
      State: input.State,
      Zip: input.Zip,
    }
    */
    const path = '/api/claim/verifycitystatezip';
    return await this.http.post(path, input);
  }

  async saveMessage(
    source: string,
    claimId: string,
    lob: string,
    sendMessageRequest: SendMessage
  ): Promise<any> {
    const path = `/api/manager/claimcommunication/${source}/${claimId}/${lob}`;

    return this.http.post<SaveMessageResponse>(
      path + '/send-message',
      sendMessageRequest
    );
  }

  async readMessage(
    source: string,
    claimId: string,
    lob: string,
    saveMessageActionRequest: SaveMessageActionRequest
  ) {
    const path = `/api/manager/claimcommunication/${source}/${claimId}/${lob}`;

    await this.http.post<number>(
      path + '/read-message',
      saveMessageActionRequest
    );
  }

  submitMileage = async (
    submitMileageRequest: SubmitMileageRequest,
    claim: SearchResult
  ) => {
    const path = `/api/mileagereimbursement/SubmitMileage`;
    return await this.http.post<SubmitMileageResponse>(
      path,
      submitMileageRequest,
      null,
      'MileageReimbursement',
      'Submit - Mileage Reimbursement',
      claim
    );
  };
}
